import { Injectable } from '@angular/core';
import { ApiHttp } from '../../../../../app/providers';
import { GetTransferOrdersResponse } from '../interfaces/get-transfer-orders-response.interface';
import { GetWalletBalanceResponse } from '../interfaces/get-wallet-balance-response.interface';
import { GetTransferOrdersRequest } from '../interfaces/get-transfer-orders-request.interface';
import { Utils } from 'app/utils';
import { MessageService } from 'primeng/api';
import { ExportFileTypeEnum } from 'app/models';

@Injectable({
  providedIn: 'root',
})
export class OrderService {
  constructor(private apiHttp: ApiHttp) {}

  public getTransferOrders(request: GetTransferOrdersRequest): Promise<GetTransferOrdersResponse> {
    return this.apiHttp.post('api/XpressTransferAdmin/GetTransferOrders', request);
  }

  public getWalletBalance(): Promise<GetWalletBalanceResponse> {
    return this.apiHttp.post('api/XpressTransferAdmin/GetWalletBalance', {});
  }

  public addNote(data: any, messageService: MessageService): Promise<any> {
    return this.apiHttp.post('api/XpressTransferAdmin/AddTransferNote', data, messageService);
  }

  public cancelTransferBooking(data: any, messageService: MessageService): Promise<any> {
    return this.apiHttp.post('api/XpressTransfer/CancelTransferBooking', data, messageService);
  }

  public exportTransferOrders(
    fileType: ExportFileTypeEnum,
    request: GetTransferOrdersRequest,
    startDate: string,
    endDate: string,
    messageService: MessageService
  ): Promise<any> {
    const dto = {
      ...request,
      FileType: fileType,
      StartDate: startDate,
      EndDate: endDate
    };

    return this.apiHttp.postDownloadFile('api/XpressTransferAdmin/ExportTransferOrders', dto, messageService);
  }
}
